const numberToWords = (num) => {
  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six",
    "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
    "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];
  const b = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  if (num === 0) return "Zero";

  const toWords = (n) => {
    let str = "";

    if (n >= 100) {
      str += a[Math.floor(n / 100)] + " Hundred";
      n %= 100;
      if (n > 0) str += " and ";
    }

    if (n >= 20) {
      str += b[Math.floor(n / 10)];
      if (n % 10 > 0) str += " " + a[n % 10];
    } else if (n > 0) {
      str += a[n];
    }

    return str;
  };

  let result = "";

  if (num >= 1000) {
    result += toWords(Math.floor(num / 1000)) + " Thousand";
    if (num % 1000 > 0) {
      if (num % 1000 < 100) {
        result += " and ";
      } else {
        result += ", ";
      }
      result += toWords(num % 1000);
    }
  } else {
    result = toWords(num);
  }

  return result.trim();
};

export default numberToWords;
